// components/Leaderboard.jsx
import React, { useState, useEffect } from 'react';
import { fetchGlobalLeaderboard } from '../api/studentApi';
import './LeaderboardPage.css';
import HeaderRouter from '../components/HeaderRouter';
import LoadingSpinner from '../components/LoadingSpinner';

const LeaderboardPage = ({ user }) => {
    const [leaders, setLeaders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLeaderboard = async () => {
            try {
                const response = await fetchGlobalLeaderboard();
                setLeaders(response.data);
            } catch (error) {
                console.error("Error fetching ranking statistics:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchLeaderboard();
    }, []);

    const getRankBadge = (rank) => {
        switch (rank) {
            case 1: return <span className="podium-badge gold">🥇</span>;
            case 2: return <span className="podium-badge silver">🥈</span>;
            case 3: return <span className="podium-badge bronze">🥉</span>;
            default: return <span className="rank-number">{rank}</span>;
        }
    };

    return (
        <>
            {/* 1. Header sits outside, allowing it to naturally stretch 100% of the screen width */}
            <HeaderRouter />

            {/* 2. The leaderboard container now safely centers just the cards and title */}
            {!loading ? (
                <div className="leaderboard-container">
                    <div className="leaderboard-header">
                        <div className="trophy-banner">🏆</div>
                        <h2>Global Hall of Fame</h2>
                        <p>Top adventurers conquering their learning journeys!</p>
                    </div>

                    <div className="leaderboard-list">
                        {leaders.map((student) => (
                            <div key={student.id} className={`leaderboard-row rank-${student.rank}`}>
                                <div className="row-left">
                                    <div className="rank-section">
                                        {getRankBadge(student.rank)}
                                    </div>
                                    <div className="avatar-placeholder-lb">
                                        {student.username.substring(0, 2).toUpperCase()}
                                    </div>
                                    <div className="student-info">
                                        <span className="student-name">{student.username}</span>
                                        {student.grade && (
                                            <span className="student-subtext">{student.grade}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="row-right">
                                    <div className="points-display">
                                        <span className="points-amount">{student.points.toLocaleString()}</span>
                                        <span className="points-label"> PTS</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div className="leaderboard-container">
                    {/* Render the generic loader neatly inside your dark layout box */}
                    <LoadingSpinner message="Loading the Hall of Fame..." size="medium" />
                </div>
            )}

        </>
    );
};

export default LeaderboardPage;